var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userInfo"},[_c('p',[_c('span',[_vm._v("用户名：")]),_c('span',[_vm._v(_vm._s(_vm.userInfo.userName))])]),_c('p',[_c('span',[_vm._v("手机号：")]),_c('span',[_vm._v(_vm._s(_vm.userInfo.mobile))])]),_c('p',[_c('span',[_vm._v("邮箱：")]),_c('span',[_vm._v(_vm._s(_vm.userInfo.email))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }